/* eslint-disable max-len */
/* eslint-disable no-param-reassign */
/* eslint-disable no-use-before-define */
/* eslint-disable no-underscore-dangle */

import { useContext,useCallback } from 'react';
import { useTranslator } from '@jutro/locale';
import { ViewModelServiceContext } from '@xengage/gw-portals-viewmodel-react';
import { MLNotificationBlockUtil } from 'ml-portals-util-react';
import { MLLocalDateUtil } from 'ml-portals-util-js';
import appConfig from 'app-config';
import _ from 'lodash';

import messages from './MLDriverVehicleUtil.messages';

const RESIDENT_STUDENT_CODE = 'PADriverResidentStudent_ML';

function MLDriverVehicleUtil(vmService) {
    const translator = useTranslator();
    const vmContext =  useContext(ViewModelServiceContext)
    const viewModelService = _.isUndefined(vmService) ? vmContext : vmService;
    const {
        clearBlockAlerts,
        addWarningAlert,
        getNumberOfAlerts
    } = MLNotificationBlockUtil();

    const vehicleFinanceCategoryTypelist = viewModelService.productMetadata.get('pc').types.getTypelist('VehicleFinanceCategory_ML');
    const driverStatusTypelist = viewModelService.productMetadata.get('pc').types.getTypelist('DriverStatusType_ML');
    const driverTypeTypelist = viewModelService.productMetadata.get('pc').types.getTypelist('DriverType_ML');
    const jurisdictionTypelist = viewModelService.productMetadata.get('pc').types.getTypelist('Jurisdiction');
    const vehicleCategoryTypelist = viewModelService.productMetadata.get('pc').types.getTypelist('VehicleCategory_ML');
    const currencyTypelist = viewModelService.productMetadata.get('pc').types.getTypelist('Currency');
    const relationshipToInsuredTypelist = viewModelService.productMetadata.get('pc').types.getTypelist('InsuredRelationType_ML');
    const genderTypeList = viewModelService.productMetadata.get('pc').types.getTypelist('GenderType');
    const vehicleTypeList = viewModelService.productMetadata.get('pc').types.getTypelist('VehicleType');
    const occupationTypeList = viewModelService.productMetadata.get('pc').types.getTypelist('OccupationType_Ext');
    const licenseStateTypeList = viewModelService.productMetadata.get('pc').types.getTypelist('Jurisdiction');
    const DEFAULT_CURRENCY = currencyTypelist.getCode('usd').code;
    const DEFAULT_AMOUNT = 0;
    const MAX_DATE_OF_BIRTH = 14;
    const MIN_DATE_OF_BIRTH = 110;
    const OLDEST_CAR_YEAR = 1900;
    const VALID_VIN_LOOK_ERROR_CODES = ['5', '4', 'N', '6', 'S', 'L', 'X'];
    const CLASSIC_VEHICLE_AGE = 10;
    const ANTIQUE_VEHICLE_AGE = 25;
    const PA_LIC_SUSP_LICENSE_SUSPENDED_TYPE = 'license_is_suspended_revoked';
    const PA_LIC_SUSP_LICENSE_SUSPENDED_CODE = '12011';
    const PA_LIC_SUSP_INCIDENT_THRESHOLD_IN_YEARS = 3;
    const PA_LIC_SUSP_DRIVERS_AGE_THRESHOLD = 24;
    const isAMP = appConfig.portalCode === 'AMP';
    const isQnB = appConfig.portalCode === 'QB';
    const currentYear = new Date().getFullYear();

    const isNotLicensed = (reason) => reason === driverStatusTypelist.getCode('never_licensed').code;
    const isLicensed = (reason) => reason !== driverStatusTypelist.getCode('never_licensed').code;
    const isAbroad = (reason) => reason === driverStatusTypelist.getCode('abroad').code;
    const abroad = driverStatusTypelist.getCode('abroad').code;
    const licenseRevoked = driverStatusTypelist.getCode('license_revoked').code;
    const insureDriver = driverStatusTypelist.getCode('insure_driver').code;
    const unwanted = driverStatusTypelist.getCode('unwanted').code;
    const ownInsurance = driverStatusTypelist.getCode('own_insurance').code;
    const neverLicensed = driverStatusTypelist.getCode('never_licensed').code;
    const permit = driverStatusTypelist.getCode('permit').code;
    const mission = driverStatusTypelist.getCode('mission').code;
    const notHousehold = driverStatusTypelist.getCode('not_household').code;
    const notresiding = driverStatusTypelist.getCode('notresiding').code;
    const duplicateDriver = driverStatusTypelist.getCode('duplicate_driver_ml').code;
    const unknown = driverStatusTypelist.getCode('unknown').code;
    const deceased = driverStatusTypelist.getCode('deceased').code;
    const discovered = driverStatusTypelist.getCode('discovered').code;
    const unableToDrive = driverStatusTypelist.getCode('unabletodrive').code;
    const registeredOwner = driverStatusTypelist.getCode('registeredowner').code;
    const DRIVERS_PATH = 'lobData.personalAuto.coverables.drivers';

    const getTypeKeyDescription = (typeKeyName) => {
        return translator({
            id: typeKeyName,
            defaultMessage: typeKeyName
        });
    };
    
    const isDriverRemovalNotAllowed = (reason) => {
        return !['license_revoked', 'never_licensed', 'unwanted', 'abroad'].includes(reason);
    };
    const isSpouseRemovalAllowed = (reason) => {
        return ['own_insurance'].includes(reason);
    };
    const isDriverRemovalRemoveNotAllowed = (reason) => {
        return ((reason !== driverStatusTypelist.getCode('license_revoked').code) && (reason !== driverStatusTypelist.getCode('not_household').code));
    };
    const directRemoveStatuses = ['unknown', 'not_household', 'notresiding'];
    const getInsureDriver = () => driverStatusTypelist.getCode('insure_driver').code;

    const isStateND = (state) => state === 'ND';
    const isStateMD = (state) => state === 'MD';
    const isStateSC = (state) => state === 'SC';
    const isStateOR = (state) => state === 'OR';
    const isStateAR = (state) => state === 'AR';
    const isStateCO = (state) => state === 'CO';
    const isAutoOneState = (state) => ['AZ', 'IL', 'WI', 'OR'].includes(state);

    const isSpouse = (driver) => driver.relationshipToInsured_ML === relationshipToInsuredTypelist.getCode('spouse').code;

    const isSpousePresent = (drivers) => {
        return drivers.find((driver) => driver.relationshipToInsured_ML === relationshipToInsuredTypelist.getCode('spouse').code);
    };

    const isSelf = (driver) => driver.relationshipToInsured_ML === relationshipToInsuredTypelist.getCode('self').code;

    const isSelfPresent = (drivers) => {
        return drivers.find((driver) => driver.relationshipToInsured_ML === relationshipToInsuredTypelist.getCode('self').code);
    };

    const getFilteredGender = (isNonBinaryState) => {
        let list;
        if (!isNonBinaryState) {
            list = _.find(genderTypeList.filters,
                (filter) => {
                    return filter.name === 'AvailableForDropDownSelection_ml';
                }).codes;
        } else {
            list = _.find(genderTypeList.filters,
                (filter) => {
                    return filter.name === 'AvailableForNon-binary';
                }).codes;
        }
        return list.map((gen) => ({
            code: gen.code,
            name: translator({
                id: gen.name,
                defaultMessage: gen.name
            })
        }));
    };
    const getMaleGenderType = () => genderTypeList.getCode('M').code;
    const getSelfRelationshipToInsured = () => relationshipToInsuredTypelist.getCode('self').code;
    const getRatedDriverType = () => driverTypeTypelist.getCode('rated').code;
    const getExcludedDriverType = () => driverTypeTypelist.getCode('excluded').code;
    const getHouseholdDriverType = () => driverTypeTypelist.getCode('household').code;
    const getOutOfHouseholdDriverType = () => driverTypeTypelist.getCode('outofhousehold').code;
    const getNonDriverType = () => driverTypeTypelist.getCode('nondriver').code;
    const getPermittedDriverType = () => driverTypeTypelist.getCode('permitted').code;
    const getOccupationTypeName = ((code) => {
        if (code === null || code === undefined || code === '') {
            return '';
        }
        const { name } = occupationTypeList.getCode(code);

        return getTypeKeyDescription(name);
    });

    const getHouseholdNonDriverType = (driver, isModernProduct = false, canExclude = false, state = '') => {
        if (isModernProduct) {
            if (canExclude) {
                if ([unknown, deceased].includes(driver.status_ML) || ([mission, abroad].includes(driver.status_ML) && (isStateSC(state)) || (isStateOR(state)))) {
                    return getNonDriverType();
                } else if ([abroad, mission, notHousehold].includes(driver.status_ML)) {
                    return getOutOfHouseholdDriverType();
                } else if ([permit].includes(driver.status_ML)) {
                    return getPermittedDriverType();
                }
                else if ((isStateOR(state) || isStateSC(state)) && [registeredOwner].includes(driver.status_ML)) {
                    return getNonDriverType();
                }
                else if ((isAutoOneState(state) && [ownInsurance].includes(driver.status_ML))) {
                    return getNonDriverType();
                } else if (isStateAR(state) && [notresiding].includes(driver.status_ML)) {
                    return getOutOfHouseholdDriverType();
                }
            } else if ([unknown, deceased, ownInsurance, neverLicensed, abroad, unableToDrive, registeredOwner, mission].includes(driver.status_ML)) {
                return getNonDriverType();
            } else if ([notHousehold].includes(driver.status_ML)) {
                return getOutOfHouseholdDriverType();
            } else if ([permit].includes(driver.status_ML)) {
                return getPermittedDriverType();
            }
            else if ([ownInsurance].includes(driver.status_ML) && isAutoOneState(state)) {
                return getNonDriverType();
            }
        } 
        return getHouseholdDriverType();
    };

    const getUmbrellaDriverTypeNewProduct = (driverStatus) => {
       if ([unknown, deceased, ownInsurance].includes(driverStatus)) {
          return getNonDriverType();
       } else if ([abroad, mission].includes(driverStatus)) {
          return getOutOfHouseholdDriverType();
       } else if ([permit].includes(driverStatus)) {
          return getPermittedDriverType();
       } else if ([licenseRevoked, unwanted, unableToDrive, registeredOwner].includes(driverStatus)) {
          return getExcludedDriverType();
       } else if ([insureDriver, discovered].includes(driverStatus)) {
          return getRatedDriverType();
       }
       return 'excluded';
    };

    const getRatedDrivers = (drivers) => (drivers ? drivers.filter((driver) => driver.type_ML === getRatedDriverType()) : []);

    const getExcludedDrivers = (drivers) => (drivers ? drivers.filter((driver) => driver.type_ML === getExcludedDriverType()) : []);

    const isTrailer = (vehicle) => {
        return vehicle.category_ML === vehicleCategoryTypelist.getCode('trailer').code;
    };

    const isTrailerNP = (vehicle) => {
        return vehicle.category_ML === vehicleCategoryTypelist.getCode('trailer_np').code;
    }

    const isCamper = (vehicle) => {
        return vehicle.category_ML === vehicleCategoryTypelist.getCode('camper_np').code;
    };

    const isLowSpeedVehicle = (vehicle) => vehicle.category_ML === vehicleCategoryTypelist.getCode('low_speed_vehicle').code;

    const isRegisteredGolfCart = (vehicle) => vehicle.category_ML === vehicleCategoryTypelist.getCode('registered_golf_cart').code;

    const isPrivatePassenger = (vehicle) => {
        return ((vehicle.category_ML === vehicleCategoryTypelist.getCode('private_passenger_light_truck').code) || (vehicle.category_ML === vehicleCategoryTypelist.getCode('private_passenger_np').code));
    }

    const isCollectible = (vehicle) => vehicle.category_ML === vehicleCategoryTypelist.getCode('collectible').code;

    const isVehicleYearPost1980 = (vehicle) => !!vehicle.year && vehicle.year > 1980;

    const isOtherPersonallyRegistered = (vehicle) => vehicle.category_ML
        === vehicleCategoryTypelist.getCode('Other_Personally_Registered').code;

    const isClassicVehicle = (vehicle) => vehicle.type_ML === vehicleTypeList.getCode('classic_ml').code;

    const isAntiqueVehicle = (vehicle) => vehicle.type_ML === vehicleTypeList.getCode('antique_ml').code;

    const isPartialVinWithoutSymbolsValid = (vehicle) => {
        return !!vehicle.year && !!vehicle.makeCode_ML && !!vehicle.modelCode_ML && !!vehicle.bodyType_ML && !!vehicle.trim_ML
            && !!vehicle.vin;
    };

    const isUnlistedModelValid = (vehicleVM) => {
        return !!vehicleVM.isUnlistedModel && !!vehicleVM.value.year && !!vehicleVM.value.makeCode_ML && !!vehicleVM.value.model && !!vehicleVM.value.bodyType_ML && !!vehicleVM.value.trim_ML;
    };

    const isStateAZ = (stateCode) => stateCode === jurisdictionTypelist.getCode('AZ').code;

    const useStateLogicForList = (stateCode, stateList) => stateList.indexOf(jurisdictionTypelist.getCode(stateCode).code) > -1;

    const isDriverRemovalExclusion = (driver, isModernProduct = false) => {
        if (isModernProduct) {
            return [driverStatusTypelist.getCode('unwanted').code,
                    driverStatusTypelist.getCode('license_revoked').code,
                    driverStatusTypelist.getCode('own_insurance').code,
                    driverStatusTypelist.getCode('never_licensed').code,
                    driverStatusTypelist.getCode('unabletodrive').code,
                    driverStatusTypelist.getCode('registeredowner').code].includes(driver.status_ML);
        }
        return [driverStatusTypelist.getCode('unwanted').code,
            driverStatusTypelist.getCode('license_revoked').code].includes(driver.status_ML);
    };

    const isDriverNeverLicensed = (driver) => {
        return [driverStatusTypelist.getCode('never_licensed').code].includes(driver.status_ML);
    };

    const getRemoveDriverExcludedOptions = useCallback((canExclude = false) => {
        const typeListValues = driverStatusTypelist.codes.filter((val) => val.code !== discovered && val.code !== insureDriver && val.code !== unwanted
                                && val.code !== unableToDrive && val.code !== registeredOwner);
        const filteredTypeListValues = canExclude ? typeListValues.filter((val) => val.code !== 'not_household' && val.code !== 'duplicate_driver_ml' 
                                && val.code !== 'deceased' && val.code !== 'unknown') : typeListValues;
        
        return filteredTypeListValues.map((category) => {
            return {
                code: category.code,
                name: translator({
                    id: category.name,
                    defaultMessage: category.name
                })
            };
        });
    }, [discovered, driverStatusTypelist.codes, insureDriver, registeredOwner, translator, unableToDrive, unwanted]);

    const getUmbrellaRemoveDriverOptions = useCallback(() => {
        const typeListValues = driverStatusTypelist.codes.filter((val) => val.code !== neverLicensed && val.code !== insureDriver && val.code !== discovered);

        return typeListValues.map((category) => {
            return {
                code: category.code,
                name: translator({
                    id: category.name,
                    defaultMessage: category.name
                })
            };
        });
    }, [discovered, driverStatusTypelist.codes, insureDriver, registeredOwner, translator, unableToDrive, unwanted]);
    const getRemoveDriverOptions = useCallback(() => {
    return driverStatusTypelist.codes.map((category) => ({
        code: category.code,
        name: translator({
            id: category.name,
            defaultMessage: category.name
        })
    }));
}, [driverStatusTypelist.codes, translator]);

    const getModernProductRemoveDriverOptions = useCallback(() => {
        const typeListValues = driverStatusTypelist.codes.filter((val) => val.code !== discovered && val.code !== insureDriver && val.code !== neverLicensed);

        return typeListValues.map((category) => {
            return {
                code: category.code,
                name: translator({
                    id: category.name,
                    defaultMessage: category.name
                })
            };
        });
    }, [discovered, driverStatusTypelist.codes, insureDriver, translator]);

    const isDriverRemovalAddHouseholdMember = (driver, isModernProduct = false, canExclude = false, policyStateCode) => {
        if (isModernProduct) {
            if (canExclude) {
                if (isStateSC(policyStateCode)) {
                    return [driverStatusTypelist.getCode('registeredowner').code,
                    driverStatusTypelist.getCode('deceased').code,
                    driverStatusTypelist.getCode('abroad').code,
                    driverStatusTypelist.getCode('not_household').code, 
                    driverStatusTypelist.getCode('mission').code,
                    driverStatusTypelist.getCode('unknown').code].includes(driver.status_ML);
                }
                else if (isStateOR(policyStateCode)) {
                    return [driverStatusTypelist.getCode('registeredowner').code,
                    driverStatusTypelist.getCode('deceased').code,
                    driverStatusTypelist.getCode('abroad').code,
                    driverStatusTypelist.getCode('not_household').code,
                    driverStatusTypelist.getCode('mission').code,                   
                    driverStatusTypelist.getCode('own_insurance').code, 
                    driverStatusTypelist.getCode('unknown').code].includes(driver.status_ML);
                }
                return [driverStatusTypelist.getCode('not_household').code,
                    driverStatusTypelist.getCode('abroad').code,
                    driverStatusTypelist.getCode('mission').code,
                    driverStatusTypelist.getCode('permit').code,
                    driverStatusTypelist.getCode('deceased').code,
                    driverStatusTypelist.getCode('unknown').code].includes(driver.status_ML);
            }

            return [driverStatusTypelist.getCode('not_household').code,
                driverStatusTypelist.getCode('abroad').code,
                driverStatusTypelist.getCode('mission').code,
                driverStatusTypelist.getCode('permit').code,
                driverStatusTypelist.getCode('deceased').code,
                driverStatusTypelist.getCode('own_insurance').code,
                driverStatusTypelist.getCode('never_licensed').code,
                driverStatusTypelist.getCode('unabletodrive').code,
                driverStatusTypelist.getCode('registeredowner').code,
                driverStatusTypelist.getCode('unknown').code].includes(driver.status_ML);
        }

        return [driverStatusTypelist.getCode('never_licensed').code,
            driverStatusTypelist.getCode('abroad').code,
            driverStatusTypelist.getCode('own_insurance').code,
            driverStatusTypelist.getCode('mission').code,
            driverStatusTypelist.getCode('permit').code,].includes(driver.status_ML);
    };

    const isDriverRemovalAddRatedDriver = (driver) => {
        return [driverStatusTypelist.getCode('insure_driver').code,
            driverStatusTypelist.getCode('discovered').code].includes(driver.status_ML);
    };

    const getNotInHouseholdDriverStatusType = () => driverStatusTypelist.getCode('not_household').code;

    const isDriverRemovalNotInHousehold = (driver) => {
        return driverStatusTypelist.getCode('not_household').code === driver.status_ML;
    };

    const isDriverRemovalDuplicate = (driver) => {
        return driverStatusTypelist.getCode('duplicate_driver_ml').code === driver.status_ML;
    };

    const isDriverRemovalDeceased = (driver) => {
        return driverStatusTypelist.getCode('deceased').code === driver.status_ML;
    };

    const isDriverRemovalUnknown = (driver) => {
        return driverStatusTypelist.getCode('unknown').code === driver.status_ML;
    };

    const driverNotExcludedOrHousehold = (driver) => {
        return driver.type_ML !== driverTypeTypelist.getCode('excluded').code
            && driver.type_ML !== driverTypeTypelist.getCode('household').code
            && driver.type_ML !== driverTypeTypelist.getCode('nondriver').code
            && driver.type_ML !== driverTypeTypelist.getCode('outofhousehold').code
            && driver.type_ML !== driverTypeTypelist.getCode('permitted').code;
    };

    const isDriverExcluded = (driver) => {
        return driver.type_ML === driverTypeTypelist.getCode('excluded').code;
    };

    const isDriverHousehold = (driver) => {
        const driverType = driver.type_ML || driver.driverType_ML
        return driverType === driverTypeTypelist.getCode('household').code ||  driverType === driverTypeTypelist.getCode('outofhousehold').code
            || driverType === driverTypeTypelist.getCode('nondriver').code ||  driverType === driverTypeTypelist.getCode('permitted').code;
    };

    const checkNoSpouse = (driver) => {
        return driver.maritalStatus_ML === 'M' && !driver.spouseID_ML;
    };

    const _sameName = (name1, name2) => {
        return name1 && name2 && name1.toUpperCase() === name2.toUpperCase();
    };

    const isSamePerson = (person1, person2) => {
        if (person1 && person2) {
            const arePublicIDsEqual = person1.publicID && person2.publicID
                && person1.publicID === person2.publicID;

            const middleName1 = person1.middleName || ' ';
            const middleName2 = person2.middleName || ' ';

            const areNamesEqual = _sameName(person1.firstName, person2.firstName)
                && _sameName(middleName1, middleName2)
                && _sameName(person1.lastName, person2.lastName);

            const areDateOfBirthsEqualOrNull = (person1.dateOfBirth && person2.dateOfBirth
                 && MLLocalDateUtil.compare(person1.dateOfBirth, person2.dateOfBirth) === 0)
                 || person1.dateOfBirth === person2.dateOfBirth;

            return arePublicIDsEqual || (areNamesEqual && areDateOfBirthsEqualOrNull);
        }
        return false;
    };

    const isAccountHolder = (submission, driver) => {
        return isSamePerson(submission.baseData.accountHolder, driver.person);
    };

    const isPrimaryNamedInsured = (submission, driver) => {
        return isSamePerson(submission.baseData.primaryNamedInsured_ML, driver.person);
    };

    const isSecondaryNamedInsured = (submission, driver) => {
        return isSamePerson(submission.baseData.secondaryNamedInsured_ML, driver.person);
    };

    const getMaxDateOfBirth = (today) => {
        // TODO ML: remove -1. A defect on the validation makes this minimum age not to be equal to the annotation one
        return {
            year: today.year - MAX_DATE_OF_BIRTH - 1,
            month: today.month,
            day: today.day
        };
    };

    const readyDriverForSave = (driver, today) => {
        let dateOfBirthToSet;
        if (driver.person) {
            dateOfBirthToSet = driver.person.dateOfBirth || getMaxDateOfBirth(today);
        } else {
            dateOfBirthToSet = getMaxDateOfBirth(today);
        }
        // eslint-disable-next-line no-param-reassign

        if (!driver.fromPrefill_ML)
            driver.dateOfBirth = dateOfBirthToSet;
        // else{
        //     driver.dateOfBirth = dateOfBirthToSet;
        // }
        // set partialDriverAdditionFlag_ML to "true" to avoid requiredness for other fields
        driver.partialDriverAdditionFlag_ML = true;

        driver.relationshipToInsured_ML = driver.relationshipToInsured_ML ;//|| getSelfRelationshipToInsured();

        driver.type_ML = driver.type_ML || getRatedDriverType();
        driver.editMode_ML = false;
    };

    const checkUniqueSelf = (drivers) => {
        const selfMatch = drivers.filter((driver) => {
            return driver.relationshipToInsured_ML === 'self' || driver.relationshipToInsured === 'self';
        });
        return selfMatch.length <= 1;
    };

    const setDefaultSelfRelation = (drivers, primaryNamedInsured = undefined) => {
        if (!_.isEmpty(drivers) && drivers.length === 1 && isSamePerson(drivers[0].person, primaryNamedInsured)) {
            drivers[0].relationshipToInsured_ML = relationshipToInsuredTypelist.getCode('self').code;
        }
    };

    const checkUniqueSpouse = (drivers) => {
        const spouseMatch = drivers.filter((driver) => {
            return driver.relationshipToInsured_ML === 'spouse' || driver.relationshipToInsured === 'spouse';
        });
        return spouseMatch.length <= 1;
    };

    const guaranteeUniqueSelf = (drivers, primaryNamedInsured = undefined) => {
        const primaryNamedInsuredIdx = drivers.findIndex((driver) => {
            return driver.person && isSamePerson(driver.person, primaryNamedInsured);
        });

        if (!checkUniqueSelf(drivers)) {
            const selfDriverIndex = primaryNamedInsuredIdx > -1
                ? primaryNamedInsuredIdx
                : drivers.findIndex((driver) => driver.relationshipToInsured_ML === 'self');

            // eslint-disable-next-line no-plusplus
            for (let i = 0; i < drivers.length; i++) {
                if (drivers[i].relationshipToInsured_ML === 'self' && selfDriverIndex !== i) {
                    drivers[i].relationshipToInsured_ML = undefined;
                }
            }
        } else if (primaryNamedInsuredIdx > -1) {
            // set the primary named insured as self if PC does not assign this value
            drivers[primaryNamedInsuredIdx].relationshipToInsured_ML = 'self';
        }
    };

    const getMinDateOfBirth = (today) => {
        return {
            year: today.year - MIN_DATE_OF_BIRTH,
            month: today.month,
            day: today.day
        };
    };

    const getMaxVehicleYears = (today) => {
        const vehicleYears = [];
        // eslint-disable-next-line no-plusplus
        for (let i = today.year + 1; i >= OLDEST_CAR_YEAR; i--) {
            vehicleYears.push(i);
        }
        return vehicleYears;
    };

    const hasErrorCodes = (vinResponse) => {
        const { error } = vinResponse;
        if (!_.isEmpty(error) || error !== undefined) {
            if (VALID_VIN_LOOK_ERROR_CODES.indexOf(error.code) >= 0) {
                return true;
            }
        }
        return false;
    };

    const getErrorCode = (vinResponse) => {
        const { error } = vinResponse;
        if (!_.isEmpty(error) || error !== undefined) {
            return error.code;
        }
        return undefined;
    };

    const getErrorDescription = (vinResponse) => {
        const { error } = vinResponse;
        if (!_.isEmpty(error) || error !== undefined) {
            return error.description;
        }
        return undefined;
    };

    const getAmountDTO = (monetary) => {
        let amount = DEFAULT_AMOUNT;
        if (!_.isEmpty(monetary) && _.isNumber(monetary.amount)) {
            amount = parseFloat(monetary.amount);
        }
        return {
            amount: amount,
            currency: DEFAULT_CURRENCY
        };
    };

    const setVinIntegrationErrorCode = (error, vehicle) => {
        if (error && error.code) {
            vehicle.vinIntegrationErrorCode_ML = error.code;
        } else {
            vehicle.vinIntegrationErrorCode_ML = '0';
        }
    };

    const mapVinResponseToVehicle = (response, vehicle) => {
        vehicle.make = response.make.description || response.make || vehicle.make;
        vehicle.makeCode_ML = response.make.code || response.make || vehicle.makeCode_ML;
        vehicle.makeCode = response.make.code || response.make || vehicle.makeCode; // pup
        vehicle.model = response.model.description || response.model || vehicle.model;
        vehicle.modelCode_ML = response.model.code || response.model || vehicle.modelCode_ML;
        vehicle.modelCode = response.model.code || response.model || vehicle.modelCode ; // pup
        vehicle.year = response.year || vehicle.year;
        vehicle.make_ML = response.make.description || response.make || vehicle.make_ML;
        vehicle.trim_ML = response.trim || response.trim_ML || vehicle.trim_ML;
        vehicle.bodyType_ML = response.bodyType || response.bodyType_ML || vehicle.bodyType_ML; // auto
        vehicle.type_ML = response.vehicleType || vehicle.type_ML;
        vehicle.bodyType = response.bodyType || vehicle.bodyType; // pup
        vehicle.fuelType_ML = response.fuelCode || vehicle.fuelType_ML;
        const responseMsrp = response.msrp.amount;
        if (responseMsrp && responseMsrp > 0) {
            vehicle.costNew = getAmountDTO(response.msrp);
        }
        vehicle.comprehensiveSymbol_ML = _.isEmpty(response.compSymbol) ? undefined : response.compSymbol;
        vehicle.collisionSymbol_ML = _.isEmpty(response.collSymbol) ? undefined : response.collSymbol;
        if (vehicle.comprehensiveSymbol_ML && vehicle.collisionSymbol_ML) {
            vehicle.compCollFilledByVinML = true;
        }
        vehicle.cylinders_ML = response.cylinders;
        vehicle.highTheftIndicator_ML = response.highTheftIndicator;
        vehicle.absBrakeCheck_ML = response.absBrakeCd;
        vehicle.antiTheftIndicator_ML = response.antiTheftIndicator;
        vehicle.passiveRestraint_ML = response.passiveRestraint;
        vehicle.daytimeRunningLight_ML = response.daytimeRunningLight;
        vehicle.performanceVehicle_ML = response.vehPerformance === 'U';
        vehicle.hasVendorAnnualMileage_ML = response.hasVendorAnnualMileage;
        vehicle.vendorAnnualMileage_ML = response.vendorAnnualMileage;
        vehicle.vendorAnnualMileageSource_ML = response.vendorAnnualMileageSource;
        vehicle.horsePowerNP = response.horsePowerNP
        //NewProduct Auto 5.0
       if (vehicle.category_ML === 'private_passenger_np') {
            vehicle.annualMileage = response.vendorAnnualMileage;
            vehicle.annualMileageSource_Ext = response.annualMileageSource_Ext;
        }   
        else { vehicle.annualMileage = response.hasVendorAnnualMileage && !vehicle.disputedVendorAnnualMileage_Ext ? null : vehicle.annualMileage;}
        vehicle.hasHistoryScore_ML = response.hasHistoryScore_ML;
        vehicle.historyScore_ML = response.historyScore_ML;
        vehicle.vintellFields_ML = response;
        setVinIntegrationErrorCode(response.error, vehicle);
    };

    const getHighestCompSymbol = (filteredVinPrefixes) => {
        return filteredVinPrefixes.reduce((prev, curr) => (prev.compSymbol > curr.compSymbol ? prev : curr));
    };

    const setVehicleInfoWithVinPrefix = (vinPrefix, vehicle) => {
        vehicle.cylinders = vinPrefix.cylinders;
        vehicle.comprehensiveSymbol_ML = vinPrefix.compSymbol;
        vehicle.collisionSymbol_ML = vinPrefix.collSymbol;
        vehicle.vin = vinPrefix.vinPrefix;
        vehicle.vIN = vinPrefix.vinPrefix;
        vehicle.isVinValidated = true;
    };

    const getModelCode = (modelCodes, model) => {
        if (modelCodes) {
            const modelCode = modelCodes.find((i) => {
                return i.description === model;
            });

            return modelCode !== undefined ? modelCode.code : null;
        }
        return undefined;
    };

    const isPropertyDefinedAndNotEmpty = (value, entity, property) => {
        return (value) && (!_.isEmpty(entity[property]) || entity[property] !== null);
    };

    const readyVehicleForSave = (vehicle) => {
        if(!vehicle.financeCategory_ML){
            vehicle.financeCategory_ML = vehicleFinanceCategoryTypelist.getCode('owned').code;
        }
        vehicle.editMode_ML = false;
    };

    const isValidYMMRequest = (req) => (req.year) && (req.makeCode) && (req.modelCode);

    const createVinLookupRequest = (vin) => {
        return {
            vin: vin
        };
    };

    const createLookupModelsRequest = (year, make) => {
        return {
            year: year,
            makeCode: make
        };
    };

    const createLookupYMMRequest = (year, make, model, quoteID) => {
        return {
            year: year,
            makeCode: make,
            modelCode: model,
            quoteID: quoteID
        };
    };

    const createLookupCompCollRequest = (year, makeCode, modelCode, quoteID, type, category, comprehensiveSymbol, collisionSymbol, costNew, trim) => {
        return {
            year,
            makeCode,
            modelCode,
            quoteID,
            category,
            type,
            comprehensiveSymbol,
            collisionSymbol,
            costNew,
            trim
        };
    };

    const createNewPersonVM = () => {
        let personVM = {};
        personVM = viewModelService.create(personVM, 'pc', 'edge.capabilities.quote.person.dto.PersonDTO');

        return personVM;
    };

    const populateDriverPerson = (driver) => {
        if (driver.person !== undefined && !_.isEmpty(driver.person)) {
            driver.person.displayName = getFullName(driver.person);
            driver.person.dateOfBirth = driver.dateOfBirth;
        }
    };

    const clearVinFields = (vehicle) => {
        vehicle.year.value = undefined;
        vehicle.make.value = undefined;
        vehicle.model.value = undefined;
        vehicle.bodyType_ML.value = undefined;
        vehicle.trim_ML.value = undefined;
        vehicle.makeCode_ML.value = undefined;
        vehicle.modelCode_ML.value = undefined;
        vehicle.collisionSymbol_ML.value = undefined;
        vehicle.comprehensiveSymbol_ML.value = undefined;
        vehicle.compCollFilledByVinML.value = undefined;
        vehicle.absBrakeCheck_ML.value = undefined;
        vehicle.performanceVehicle_ML.value = undefined;
        
         if(vehicle.costNew && vehicle.costNew.amount){
            vehicle.costNew.amount.value = undefined;
        };
        
        vehicle.highTheftIndicator_ML.value = undefined;
        vehicle.vendorAnnualMileageSource_ML.value = undefined;
        vehicle.vendorAnnualMileage_ML.value = undefined;
        vehicle.daytimeRunningLight_ML.value = undefined;
        vehicle.antiTheftIndicator_ML.value = undefined;
        vehicle.hasHistoryScore_ML.value = undefined;
        vehicle.historyScore_ML.value = undefined;
        vehicle.passiveRestraint_ML.value = undefined;
        vehicle.cylinders_ML.value = undefined;
        vehicle.isVinVerifiedSuccessfully_ML.value = undefined;
        vehicle.isTrimVinConfirmed_Ext.value = false;
    };

    const clearPupVinFields = (vehicle) => {
        vehicle.year.value = undefined;
        vehicle.make.value = undefined;
        vehicle.makeCode.value = undefined;
        vehicle.value.selectedMake = undefined;
        vehicle.model.value = undefined;
        vehicle.modelCode.value = undefined;
        vehicle.bodyType.value = undefined;
        vehicle.trim_ML.value = undefined;
    };

    // TODO ML jlucente US12735: remove when business rule is implemented in pc for only having trailer in a personal auto policy
    const createOnlyTrailerError = (quoteID) => {
        return {
            customError: {
                code: -31000,
                contactUsMessage: isQnB ? messages.OnlyTrailerErrorMessageQnB : messages.OnlyTrailerErrorMessage,
                quoteID
            }
        };
    };

    const setDriverForPartialCreation = (driver) => {
        driver.partialDriverAdditionFlag_ML = true;
    };

    const setDriversForPartialCreation = (drivers) => {
        drivers.forEach((driver) => {
            setDriverForPartialCreation(driver);
        });
    };

    const createValidationObj = (entity, against, model) => {
        return {
            hasError: false,
            errorMessage: null,
            entity: entity,
            toBeValidatedAgainst: against,
            action: null,
            model: model
        };
    };

    const uniqueDriversExcludingDriver = (driverToNotInclude, drivers) => drivers.filter((driver) => driver !== driverToNotInclude);

    const uniqueVehiclesExcludingVehicle = (vehicleToNotInclude, vehicles) => vehicles.filter((vehicle) => vehicle.tempID !== vehicleToNotInclude.tempID);

    const validator = (validations, index, validationObj) => {
        if (index < validations.length) {
            validations[index](validationObj);
            if (validationObj.hasError) {
                return;
            }
            // eslint-disable-next-line no-plusplus
            index++;
            validator(validations, index, validationObj);
        }
    };

    const onlyOneSpouse = (validationObj) => {
        if (isSpouse(validationObj.entity)) {
            const otherDrivers = uniqueDriversExcludingDriver(validationObj.entity, validationObj.toBeValidatedAgainst);
            if (isSpousePresent(otherDrivers)) {
                validationObj.hasError = true;
                validationObj.errorMessage = translator(messages.SpouseWasAlreadySelected);
            }
        }
    };

    const onlyOneSelf = (validationObj) => {
        if (isSelf(validationObj.entity)) {
            const otherDrivers = uniqueDriversExcludingDriver(validationObj.entity, validationObj.toBeValidatedAgainst);
            if (isSelfPresent(otherDrivers)) {
                validationObj.hasError = true;
                validationObj.errorMessage = translator(messages.SpouseWasAlreadySelected);
            }
        }
    };

    const validateDriverAddition = (driverToValidate, driversToValidateAgainst) => {
        const driverValidationObj = createValidationObj(driverToValidate, driversToValidateAgainst);
        const index = 0;
        const validations = [];
        validations.push(onlyOneSpouse);
        validations.push(onlyOneSelf);
        validator(validations, index, driverValidationObj);

        return driverValidationObj;
    };

    const validateExcludedDriverAddition = (driver, modelVM, driverList) => {
        if (driver.dateOfBirth) {
            driver.person.dateOfBirth.value = driver.dateOfBirth.value;
        }
        if (driver.contact && (driver.contact.dateOfBirthForNonDriver.value)) {
            driver.contact.dateOfBirth.value = driver.contact.dateOfBirthForNonDriver.value;
        }
        const driverValidationObj = createValidationObj(driver, driverList, modelVM);
        const index = 0;
        const validations = [];
        if (_.get(modelVM, 'baseData.value.jobType') === 'PolicyChange') {
            validations.push(cannotAddExcludedDriverSameAsNamedInsuredForEndorsement);
            validations.push(cannotAddExcludedDriverSameAsSecondaryNamedInsuredForEndorsement);
        } else if (modelVM.baseData) {
            validations.push(cannotAddExcludedDriverSameAsNamedInsuredForSubmission);
            validations.push(cannotAddExcludedDriverSameAsSecondaryNamedInsuredForSubmission);
        }
        validator(validations, index, driverValidationObj);

        return driverValidationObj;
    };

    const cannotAddExcludedDriverSameAsNamedInsuredForEndorsement = (validationObj) => {
        const endorsementVM = validationObj.model;
        const driver = validationObj.entity;
        const driverList = validationObj.toBeValidatedAgainst;
        const primaryNamedInsured = _getPrimaryNamedInsured(endorsementVM, driverList);
        const driverPerson = _getPerson(endorsementVM, driver);
        const polState = endorsementVM.baseData.policyAddress.state.value.code;
        const primaryNamedInsuredPerson = _getPerson(endorsementVM, primaryNamedInsured);
        const reasonForRemoval = _.get(driver, 'status_ML.value.code') || _.get(driver, 'driverStatusForAdding.value.code');
        if ((isStateND(polState) || isStateMD(polState))) {
            if ((reasonForRemoval === 'unwanted') && primaryNamedInsured && isSamePerson(primaryNamedInsuredPerson, driverPerson.value)) {
                _.set(primaryNamedInsured, 'value.type_ML', getExcludedDriverType());
            } else if ((reasonForRemoval === 'insure_driver') && primaryNamedInsured && isSamePerson(primaryNamedInsuredPerson, driverPerson.value)) {
                _.set(primaryNamedInsured, 'value.type_ML', getRatedDriverType());
            } else if (isDriverRemovalRemoveNotAllowed(reasonForRemoval) && primaryNamedInsured && isSamePerson(primaryNamedInsuredPerson, driverPerson.value)) {
                validationObj.hasError = true;
                validationObj.errorMessage = _getExcludingNamedInsuredMessage(driver);
            }
        } else if (primaryNamedInsured && isSamePerson(primaryNamedInsuredPerson, driverPerson.value)) {
            validationObj.hasError = true;
            validationObj.errorMessage = _getExcludingNamedInsuredMessage(driver);
        }
    };

    const cannotAddExcludedDriverSameAsNamedInsuredForSubmission = (validationObj) => {
        const submission = validationObj.model;
        const driver = validationObj.entity;
        const primaryNamedInsured = submission.baseData.primaryNamedInsured_ML.value;
        const driverPerson = _getPerson(submission, driver);
        if (primaryNamedInsured && isSamePerson(primaryNamedInsured, driverPerson.value)) {
            validationObj.hasError = true;
            validationObj.errorMessage = _getExcludingNamedInsuredMessage(driver);
        }
    };

    const cannotAddExcludedDriverSameAsSecondaryNamedInsuredForEndorsement = (validationObj) => {
        const endorsementVM = validationObj.model;
        const driver = validationObj.entity;
        const secondaryNamedInsured = endorsementVM.baseData.secondaryNamedInsured_ML ? endorsementVM.baseData.secondaryNamedInsured_ML.value : null;
        const driverPerson = _getPerson(endorsementVM, driver);
        const polState = endorsementVM.baseData.policyAddress.state.value.code;
        const reasonForRemoval = _.get(driver, 'status_ML.value.code') || _.get(driver, 'driverStatusForAdding.value.code');
        if (isStateND(polState) || isStateMD(polState)) {
            if ((reasonForRemoval === 'unwanted') && secondaryNamedInsured && isSamePerson(secondaryNamedInsured, driverPerson.value)) {
                _.set(secondaryNamedInsured, 'value.type_ML', getExcludedDriverType());
            } else if (isDriverRemovalRemoveNotAllowed(reasonForRemoval) && secondaryNamedInsured && isSamePerson(secondaryNamedInsured, driverPerson.value)) {
                validationObj.hasError = true;
                validationObj.errorMessage = _getExcludingSecondaryNamedInsuredMessage(driver);
            }
        } else if (secondaryNamedInsured && isSamePerson(secondaryNamedInsured, driverPerson.value)) {
            validationObj.hasError = true;
            validationObj.errorMessage = _getExcludingSecondaryNamedInsuredMessage(driver);
        }
    };

    const cannotAddExcludedDriverSameAsSecondaryNamedInsuredForSubmission = (validationObj) => {
        const submission = validationObj.model;
        const driver = validationObj.entity;
        const secondaryNamedInsured = submission.baseData.secondaryNamedInsured_ML ? submission.baseData.secondaryNamedInsured_ML.value : null;
        const driverPerson = _getPerson(submission, driver);
        if (secondaryNamedInsured && isSamePerson(secondaryNamedInsured, driverPerson.value)) {
            validationObj.hasError = true;
            validationObj.errorMessage = _getExcludingSecondaryNamedInsuredMessage(driver);
        }
    };

    const _getPrimaryNamedInsured = (modelVM, driverList) => {
        let PNI;
        if (modelVM.value.isPersonalUmbrella()) {
            PNI = driverList.find((driverPrimaryNamedInsured) => driverPrimaryNamedInsured.relationshipToInsured === getSelfRelationshipToInsured());
        } else if (modelVM.value.isPersonalAuto()) {
            PNI = driverList.find((driverPrimaryNamedInsured) => driverPrimaryNamedInsured.relationshipToInsured_ML === getSelfRelationshipToInsured());
            if (PNI.dateOfBirth && !PNI.person.dateOfBirth) {
                PNI.person.dateOfBirth = PNI.dateOfBirth;
            }
        }
        return PNI;
    };

    const _getExcludingNamedInsuredMessage = (driver) => {
        const msg = (((driver.type_ML) && isDriverExcluded(driver.value))
            || ((driver.driverType) && driver.driverType.value.code === 'excluded'))
            ? translator(messages.NotAValidReasonToExcludeTheNamedInsured)
            : translator(messages.NotAValidReasonToRemoveTheNamedInsured);
        return msg;
    };

    const _getExcludingSecondaryNamedInsuredMessage = (driver) => {
        const msg = (((driver.type_ML) && isDriverExcluded(driver.value))
            || ((driver.driverType) && driver.driverType.value.code === 'excluded'))
            ? translator(messages.NotAValidReasonToExcludeSecondaryNamedInsured)
            : translator(messages.NotAValidReasonToRemoveSecondaryInsured);
        return msg;
    };

    const _getPerson = (modelVM, driver) => {
        return modelVM.value.isPersonalUmbrella() ? driver.contact : driver.person;
    };

    const validateLastDriverDriverRemoval = (drivers, sub) => {
        const driverValidationObj = createValidationObj(drivers, null, sub);
        const index = 0;
        const validations = [];
        validations.push(cannotRemoveLastDriver);
        validator(validations, index, driverValidationObj);

        return driverValidationObj;
    };

    const validateDriverRemoval = (driverToValidate, sub) => {
        const driverValidationObj = createValidationObj(driverToValidate, null, sub);
        const index = 0;
        const validations = [];
        validations.push(cannotRemoveSpouseIfLicensed);
        validations.push(cannotRemoveLastDriver);
        validations.push(cannotExcludeNamedInsured);
        validations.push(cannotExcludeSecondaryNamedInsured);
        validations.push(cannotExclude);
        validations.push(householdAndExclusionRequiredFields);
        validator(validations, index, driverValidationObj);

        return driverValidationObj;
    };

    const validateAntiqueVehicleAge = (vehicleToValidate, policyEffectiveDate) => {
        const validationObj = {};
        validationObj.entity = vehicleToValidate.value;
        validationObj.policyEffectiveDate = policyEffectiveDate;
        validationObj.hasError = false;
        const index = 0;
        const validations = [];
        validations.push(antiqueVehicleAge);
        validator(validations, index, validationObj);

        return validationObj;
    };

    const validateClassicVehicleAge = (vehicleToValidate, policyEffectiveDate) => {
        const validationObj = {};
        validationObj.entity = vehicleToValidate.value;
        validationObj.policyEffectiveDate = policyEffectiveDate;
        validationObj.hasError = false;
        const index = 0;
        const validations = [];
        validations.push(classicVehicleAge);
        validator(validations, index, validationObj);

        return validationObj;
    };

    const validateVehicleAddition = (vehicleToValidate, vehiclesToValidateAgainst, policyEffectiveDate) => {
        const vehicleValidationObj = createValidationObj(vehicleToValidate, vehiclesToValidateAgainst);
        vehicleValidationObj.policyEffectiveDate = policyEffectiveDate;
        const index = 0;
        const validations = [];
        validations.push(duplicateVin);
        validations.push(classicVehicleAge);
        validations.push(antiqueVehicleAge);
        validator(validations, index, vehicleValidationObj);

        return vehicleValidationObj;
    };

    const validateAgentPrefillNextStep = (submission) => {
        const prefillValidationObj = createValidationObj(submission);
        const index = 0;
        const validations = [];
        validations.push(hasOnlyTrailers);
        validator(validations, index, prefillValidationObj);

        return prefillValidationObj;
    };

    const hasOnlyTrailers = (validationObj) => {
        const { vehicles } = validationObj.entity.lobData.personalAuto.coverables;
        const isModernProduct = validationObj.entity?.isModernProduct_Ext;
        if (vehicles.length > 0) {
            const hasTrailer = vehicles.some(vehicle => isTrailer(vehicle) && !vehicle.removed);
            const hasTrailerNP = vehicles.some(vehicle => isTrailerNP(vehicle) && !vehicle.removed);
            const hasCamper = vehicles.some(vehicle => isCamper(vehicle) && !vehicle.removed);
            const hasOther = vehicles.some(vehicle => !isTrailer(vehicle) && !isTrailerNP(vehicle) && !isCamper(vehicle) && !vehicle.removed);

            if (!hasOther && (hasTrailer || hasCamper || hasTrailerNP)) {
                validationObj.hasError = true;
                validationObj.errorMessage = translator(
                    isModernProduct
                        ? messages.ATrailerOrCamperCannotBeTheOnlyVehicleOnThePolicy
                        : messages.ATrailerCannotBeTheOnlyVehicleOnThePolicy
                );
            }
        }
    };
    // TODO: revisit to confirm the changes of merge
    /*
    retaining r_1_7 as comments
        const cannotRemoveLastDriver = validationObj => {
        if (validationObj.submission === undefined) {
            const drivers = validationObj.entity;
            if (drivers.filter(d => d.type_ML === 'rated').length === 1) {
                validationObj.hasError = true;
                validationObj.errorMessage = $filter('translate')('common.util.MLDriverVehicleUtil.At least one driver must be listed as a rated driver to continue.');
            }
        } else {
        const drivers = (validationObj.submission) ? validationObj.submission.draftData.lobs.personalAuto.drivers : validationObj.toBeValidatedAgainst;
        if (drivers.filter(d => d.type_ML === 'rated').length === 1) {
            validationObj.hasError = true;
            validationObj.errorMessage = $filter('translate')('common.util.MLDriverVehicleUtil.At least one driver must be listed as a rated driver to continue.');
        }
        }
    };
    */
    const cannotRemoveLastDriver = (validationObj) => {
        const submission = validationObj.model;
        const { drivers } = submission.lobData.personalAuto.coverables;
        if (drivers.filter((d) => d.type_ML === 'rated').length === 1) {
            const ratedDriver = drivers.find((d) => d.type_ML === 'rated');
            if (ratedDriver.status_ML && (ratedDriver.status_ML !== 'insure_driver' || ratedDriver.status_ML !== 'discovered')) {
                validationObj.hasError = true;
                validationObj.errorMessage = translator(messages.AtLeastOneDriverMustBeListedAsRatedDriver);
            }
        }
    };

    const cannotRemoveSpouseIfLicensed = (validationObj) => {
        const reasonForRemoval = validationObj.entity.status_ML;
        const driverState = validationObj.model.baseData.policyAddress.state;
        const isModernProduct = validationObj.model.isModernProduct_Ext
        if (isStateND(driverState) || isStateMD(driverState)) {
            if (isSpouse(validationObj.entity) && isDriverRemovalNotAllowed(reasonForRemoval)) {
                validationObj.hasError = true;
                validationObj.errorMessage = translator(messages.SpouseCannotBeRemoved);
            }
        }
        else if (isModernProduct && isSpouse(validationObj.entity) && (isSpouseRemovalAllowed(reasonForRemoval) || isStateCO(driverState))) {
            validationObj.hasError = false;
        } else if (isSpouse(validationObj.entity) && !(isNotLicensed(reasonForRemoval) || (!isAMP && isAbroad(reasonForRemoval)))) {
            validationObj.hasError = true;
            validationObj.errorMessage = translator(messages.SpouseCannotBeRemoved);
        }
    };

    const cannotExcludeNamedInsured = (validationObj) => {
        const submission = validationObj.model;
        const driver = validationObj.entity;
        const isForExclusion = isDriverRemovalExclusion(driver);
        const driverState = submission.baseData.policyAddress.state;
        if (driver.person && !driver.person.dateOfBirth && driver.dateOfBirth) {
            driver.person.dateOfBirth = driver.dateOfBirth;
        }
        if (!isStateND(driverState) && isPrimaryNamedInsured(submission, driver) && isForExclusion) {
            validationObj.hasError = true;
            validationObj.errorMessage = translator(messages.NotAValidReasonToRemoveTheNamedInsured);
        }
    };

    const cannotExcludeSecondaryNamedInsured = (validationObj) => {
        const submission = validationObj.model;
        const driver = validationObj.entity;
        const isForExclusion = isDriverRemovalExclusion(driver);
        const driverState = submission.baseData.policyAddress.state;
        if (driver.person && !driver.person.dateOfBirth && driver.dateOfBirth) {
            driver.person.dateOfBirth = driver.dateOfBirth;
        }
        if (!isStateND(driverState) && !isStateCO(driverState) && isSecondaryNamedInsured(submission, driver) && isForExclusion) {
            validationObj.hasError = true;
            validationObj.errorMessage = translator(messages.NotAValidReasonToRemoveSecondaryInsured);
        }
    };

    const cannotExclude = (validationObj) => {
        const submission = validationObj.model;
        const driver = validationObj.entity;
        const policyStateCode = submission.baseData.policyAddress.state
        const canExclude = submission.baseData.canExcludeDrivers_ML;
        const isForExclusion = isDriverRemovalExclusion(driver);
        if (!canExclude && isForExclusion) {
            validationObj.hasError = true;
            validationObj.errorMessage = translator(messages.NotAValidReasonToRemoveThisDriver);
        }
        else if(canExclude && isForExclusion && isStateSC(policyStateCode)){
            validationObj.hasError = true;
            validationObj.errorMessage = translator(messages.NotAValidReasonToRemoveThisDriver);
        }
    };

    const householdAndExclusionRequiredFields = (validationObj) => {
        const driver = validationObj.entity;
        const isModernProduct = validationObj.model?.isModernProduct_Ext ? validationObj.model.isModernProduct_Ext : false;
        const isForExclusion = isDriverRemovalExclusion(driver, isModernProduct);
        const isForHousehold = isDriverRemovalAddHouseholdMember(driver, isModernProduct);
        const requiredFields = driver.person.firstName && driver.person.lastName && (isQnB && driver.fromPrefill_ML ? true : driver.dateOfBirth) && driver.gender && driver.relationshipToInsured_ML;
        if (!requiredFields && (isForExclusion || (isForHousehold && !directRemoveStatuses.includes(driver.status_ML)))) {
            validationObj.hasError = true;
            validationObj.errorMessage = translator(messages.requiredFieldsForHouseholdRemovalsAndExclusions);
        }
    };

    const qnBDobFieldVisibility = (driver, isModernProduct = false) => {
        const isForExclusion = isDriverRemovalExclusion(driver, isModernProduct);
        const isForHousehold = isDriverRemovalAddHouseholdMember(driver, isModernProduct);
        return ((isForExclusion || (isForHousehold && !directRemoveStatuses.includes(driver.status_ML))))
    };

    const calculateAge = (dateOfBirth) => {
        const { day, month, year } = dateOfBirth;
        const dob = new Date(year, month - 1, day);
        const today = new Date();
        let age = today.getFullYear() - dob.getFullYear();
        // Adjust if birthday hasn't occurred yet this year
        const hasHadBirthdayThisYear =
            today.getMonth() > dob.getMonth() ||
            (today.getMonth() === dob.getMonth() &&
                today.getDate() >= dob.getDate());
        if (!hasHadBirthdayThisYear) {
            age--;
        }
        return age;
    }

    const getDriversAge = (driver) => {
        const age = calculateAge(driver.dateOfBirth)
        if (age < 22) {
            return true
        } else { return false }
    };

    const getSpouseAge = (driver) => {
        const age = calculateAge(driver.dateOfBirth)
        if (age >= 30 && isSpouse(driver)) {
            return true
        } else { return false }
    }

    const getPNIAge = (submissionVM) => {       
        const driverList = _.get(submissionVM, `${DRIVERS_PATH}.value`, {});
        const PNI = driverList.find(d => d.relationshipToInsured_ML === getSelfRelationshipToInsured());
        const age = calculateAge(PNI.dateOfBirth)
        if (age >= 30) {
            return true
        } else { return false }
    }

    const getDriverMaritalStatus = (driver) => {
        if (driver.maritalStatus_ML === 'S' || driver.maritalStatus_ML === 'P') {
            return true
        } else { return false }
    }

    const checkDriverRemovalCondition = (submissionVM, driverToRemove) => {        
        if (getDriversAge(driverToRemove) && getDriverMaritalStatus(driverToRemove) && (getPNIAge(submissionVM) || getSpouseAge(driverToRemove))) {
            return true
        } else {
            return false;
        }
    }

    const checkIfNonDriver = (driverToRemove) => {
        const isPrefill = driverToRemove.partialDriverAdditionFlag_ML;
        const spouse = isSpouse(driverToRemove);
        if (spouse) {
            return !!getSpouseAge(driverToRemove);
        }
        return isPrefill ? !!getDriversAge(driverToRemove) : !!(getDriversAge(driverToRemove) && getDriverMaritalStatus(driverToRemove));
    };
 

    const duplicateVin = (validationObj) => {
        let vinAlreadyUsed = -1;
        if (validationObj.entity.vin) {
            const otherVehicles = uniqueVehiclesExcludingVehicle(validationObj.entity, validationObj.toBeValidatedAgainst);
            vinAlreadyUsed = otherVehicles.findIndex((vehicle) => vehicle.vin === validationObj.entity.vin);
            if (vinAlreadyUsed >= 0) {
                validationObj.hasError = true;
                validationObj.errorMessage = translator(messages.VinNumberHasAlreadyBeenListed);
            }
        }
    };

    const classicVehicleAge = (validationObj) => {
        if (isClassicVehicle(validationObj.entity) && !!validationObj.entity.year) {
            const polEffYear = validationObj.policyEffectiveDate.year;
            if (polEffYear - validationObj.entity.year < CLASSIC_VEHICLE_AGE) {
                validationObj.hasError = true;
                validationObj.errorMessage = translator(messages.QualifyAsAClassicVehicle, { numYears: CLASSIC_VEHICLE_AGE });
            }
        }
    };

    const antiqueVehicleAge = (validationObj) => {
        if (isAntiqueVehicle(validationObj.entity) && !!validationObj.entity.year) {
            const polEffYear = validationObj.policyEffectiveDate.year;
            if (polEffYear - validationObj.entity.year < ANTIQUE_VEHICLE_AGE) {
                validationObj.hasError = true;
                validationObj.errorMessage = translator(messages.QualifyAsAnAntiqueVehicle, { numYears: ANTIQUE_VEHICLE_AGE });
            }
        }
    };

    const hasCompCollSymbolsNoYear = (vehicleInfo) => {
        return vehicleInfo.collSymbol && vehicleInfo.compSymbol && !vehicleInfo.year;
    };

    const validateQuotedCollAndCompCovsRequired = (submissionVM, vehiclesVM) => {
        const chosenQuote = _.find(submissionVM.quoteData.offeredQuotes.value, { publicID: submissionVM.bindData.chosenQuote.value });
        const { vehicleCoverages } = chosenQuote.lobs.personalAuto;
        const errorMessages = [];
        _.every(vehiclesVM, (vehicleVM) => {
            if (vehicleVM.value.financeCategory_ML === 'financed' || vehicleVM.value.financeCategory_ML === 'leased') {
                const allCoverages = _.find(vehicleCoverages, { fixedId: vehicleVM.value.fixedId }).coverages;
                if (_.find(allCoverages, { code_ML: 'PACollisionCov' || 'PAComprehensiveCov', selected: false })) {
                    errorMessages.push({
                        message: translator(messages.UnableToDeleteCollisionAndComprehensive)
                    });
                    return false;
                }
            }
            return true;
        });
        return errorMessages;
    };

    const validateVehiclesSerialNumber = (vehiclesVM) => {
        return !vehiclesVM.some(
            (vehicle) => !vehicle.namedNonOwner_ML.value
                && (isRegisteredGolfCart(vehicle.value) || isLowSpeedVehicle(vehicle.value) || isTrailer(vehicle.value))
                && (vehicle.serialNumber_ML.value === undefined || vehicle.serialNumber_ML.value.length === 0)
        );
    };

    const isVendorAnnualMileageForPA = (state, vehicle) => {
        return (state === 'PA') && vehicle.hasVendorAnnualMileage_ML.value;
    };

    const canDisplayAnnualMileage = (vehicle) => {
        return !vehicle.hasVendorAnnualMileage_ML.value || ((vehicle.disputedVendorAnnualMileage_Ext) && vehicle.disputedVendorAnnualMileage_Ext.value);
    };

    const ageLessThanThreshold = (driver) => {
        return currentYear - driver.dateOfBirth.year < PA_LIC_SUSP_DRIVERS_AGE_THRESHOLD;
    };

    const isSuspension = (violation) => {
        return currentYear - violation.date.year < PA_LIC_SUSP_INCIDENT_THRESHOLD_IN_YEARS && (violation.type === PA_LIC_SUSP_LICENSE_SUSPENDED_TYPE || violation.code === PA_LIC_SUSP_LICENSE_SUSPENDED_CODE);
    };

    const hasPASuspension = (driver) => {
        return driver.disclosures_ML.violations.some((violation) => isSuspension(violation));
    };

    const getState = (submissionVM) => {
        if (submissionVM.value.policyAddress) {
            return submissionVM.value.policyAddress.state;
        }
        if (submissionVM.value.baseData.policyAddress) {
            return submissionVM.value.baseData.policyAddress.state;
        }
        return null;
    };

    const getDrivers = (submissionVM) => {
        if (submissionVM.value.lobData) {
            return submissionVM.value.lobData.personalAuto.coverables.drivers;
        }
        return null;
    };

    const pADriverSuspended = (submissionVM) => {
        return getState(submissionVM) === 'PA' && getDrivers(submissionVM).some((driver) => {
            return ageLessThanThreshold(driver) && hasPASuspension(driver);
        });
    };

    const displayPADriverSuspendedMessage = () => {
        if (getNumberOfAlerts('PADriverSuspension') <= 0) {
            addWarningAlert(messages.IfTheSuspensioinForTheDriver, 'PADriverSuspension');
        }
    };

    const unobtainableDriverLicense = (licenseState) => {
        return licenseState.value.code === licenseStateTypeList.getCode('ca_ml').code || licenseState.value.code === licenseStateTypeList.getCode('ust_ml').code;
    };

    const displayUnobtainableDriverLicenseMessage = (isGpa) => {
        if (getNumberOfAlerts('UnobtainableDriverLicenseMessage') <= 0) {
            const alertLicenseStateMessage = isGpa
                ? messages.OneOfMoreDriversHasACanadianUSTerritoryLicense
                : messages.UnableToVerifyMVR;
            addWarningAlert(alertLicenseStateMessage, 'UnobtainableDriverLicenseMessage');
        }
    };

    const clearUnobtainableDriverLicenseMessage = () => {
        if (getNumberOfAlerts('UnobtainableDriverLicenseMessage') > 0) {
            clearBlockAlerts('UnobtainableDriverLicenseMessage');
        }
    };

    const displayNonAccidentPreventionModifierMessage = () => {
        if (getNumberOfAlerts('NonAccidentPreventionMsg') <= 0) {
            addWarningAlert(messages.ToReceiveAccidentPreventionCourseDiscount, 'NonAccidentPreventionMsg');
        }
    };

    const clearAccidentPreventionMessage = () => {
        if (getNumberOfAlerts('NonAccidentPreventionMsg') > 0) {
            clearBlockAlerts('NonAccidentPreventionMsg');
        }
    };

    const displayNonAPModifierLAMessage = () => {
        if (getNumberOfAlerts('NonAccidentPreventionLAMsg') <= 0) {
            addWarningAlert(messages.AllDriversAssignedMustHaveCompletedDriverSafetyCourse, 'NonAccidentPreventionLAMsg');
        }
    };

    const getVehicleDiscountMessage = (vehicle) => {
        let warningMsg = '';
        switch (vehicle.carVTDEEligibilityStatus) {
            case 'not_eligible':
                warningMsg = translator(messages.vehicleNotEligible, {vin: vehicle.vin});
                break;
            case 'invalid_vin':
                warningMsg = translator(messages.vehicleInvalidVin, {vin: vehicle.vin});
                break;
            case 'eligible':
                if (vehicle.vin && vehicle.vin.length === 17) {
                    warningMsg = translator(messages.vehicleNotEnrolled, {vin: vehicle.vin});
                } else {
                    warningMsg = translator(messages.vehicleNotEnrolledPartialVin, {vin: vehicle.vin});
                }
                break;
            case 'cancelled':
                warningMsg = translator(messages.vehicleEnrolStatusCancelled, {vin: vehicle.vin});
                break;
            default:
                return;
        }
        return warningMsg;
    };

    const showConnectedCarModifierAlert = (vehicles) => {
        const alertName = 'vehicleConectedCarWarning_';

        vehicles.forEach((vehicle) => {
            if (vehicle.showDiscountMessageInPortals_Ext) {
                addWarningAlert(getVehicleDiscountMessage(vehicle), alertName.concat(vehicle.vin));
                vehicle.showDiscountMessageInPortals_Ext = false;
            }
        });
    };

    // NEW
    const getFullName = (person) => {
        const nameSuffixList = viewModelService.productMetadata.get('pc').types.getTypelist('NameSuffix');
        const firstName = person.firstName ?? '';
        const middleName = person.middleName ?? '';
        const lastName = person.lastName ?? '';
        const suffixTypeKeyName = (person.suffix) ? nameSuffixList.getCode(person.suffix).name : '';
        const suffixDisplayName = translator(
            {
                id: suffixTypeKeyName,
                defaultMessage: ' '
            }
        );
        return `${firstName} ${middleName} ${lastName} ${suffixDisplayName}`;
    };

    const setDriversForFullAddition = (drivers) => {
        drivers.forEach((driver) => {
            driver.partialDriverAdditionFlag_ML = false;
            driver.editMode_ML = true;
        });
    };

    const setDefaultStatusForRatedDriver = (drivers) => {
        drivers.forEach((driver) => {
            if (driver.type_ML === 'rated' && !driver.status_ML) {
                driver.status_ML = 'insure_driver';
            }
        });
    };

    const setModifierEditMode = (drivers, editMode) => drivers.forEach((driver) => {
        if (driver.driverModifiers_ML && driver.driverModifiers_ML.modifiers && driver.driverModifiers_ML.modifiers.length) {
            driver.driverModifiers_ML.modifiers.forEach((mod) => {
                mod.editMode_ML = editMode;
            });
        }
    });

    const isAccidentPreventionCourse = (drivers, policyStateCode) => {
        const accidentPreventionCode = 'PADriversRoleModiferPreventionCourse_ML';

        let nonAcciPrevModifier = false;
        if (policyStateCode === 'GA') {
            drivers.forEach((driver) => {
                if (driver.driverModifiers_ML.modifiers) {
                    driver.driverModifiers_ML.modifiers.forEach((modifier) => {
                        if (modifier.codeIdentifier_ML === accidentPreventionCode) {
                            if (modifier.chosenTermValue === 'false') nonAcciPrevModifier = true;
                        }
                    });
                }
            });
        }
        return nonAcciPrevModifier;
    };

    const validatePersonAndSpouseMatch = (person, spouse) => {
        let samePerson = false;
        if (person.publicID && spouse.publicID) {
            samePerson = person.publicID === spouse.publicID;
        } else {
            const validateName = (person.firstName === spouse.firstName && person.lastName === spouse.lastName) || false;

            let validateMaritalStatus = false;
            if (spouse.maritalStatus && spouse.maritalStatus.code) {
                validateMaritalStatus = person.maritalStatus === spouse.maritalStatus.code || false;
            }

            let validateDateOfBirth = false;
            if (spouse.dateOfBirth.value) {
                validateDateOfBirth = (person.dateOfBirth.day === spouse.dateOfBirth.day
                    && person.dateOfBirth.month === spouse.dateOfBirth.month
                    && person.dateOfBirth.year === spouse.dateOfBirth.year) || false;
            }
            samePerson = validateName && validateDateOfBirth && validateMaritalStatus;
        }
        return samePerson;
    };

    const setSpousesForDriver = (drivers) => {
        if (drivers.length > 1) {
            drivers.forEach((driver) => {
                if (driver.spouse_ML && driver.spouse_ML.publicID) {
                    const spouse = driver.spouse_ML;
                    const personsCorrespondingToSpouse = drivers.find((pdriver) => validatePersonAndSpouseMatch(pdriver.person, spouse));
                    if (personsCorrespondingToSpouse) {
                        driver.spouse_ML = personsCorrespondingToSpouse.person;
                    }
                }
            });
        }
    };

    const isVehicleEligibleForAccidentPrevention = (vehicle) => {
        return vehicle && ((vehicle.category_ML === 'private_passenger_light_truck') || (vehicle.category_ML === 'private_passenger_np')
            || (vehicle.category_ML === 'collectible' && (vehicle.type_ML === 'classic_ml' || vehicle.type_ML === 'replica_ml' || vehicle.type_ML === 'custom_ml')));
    };

    const getRatedDriversNonStudent = (drivers) => {
        return drivers.filter((driver) => {
            const residentStudentModifier = driver.driverModifiers_ML.modifiers.find((mod) => mod.codeIdentifier_ML === RESIDENT_STUDENT_CODE);
            return driver.type_ML === getRatedDriverType() && (!residentStudentModifier || residentStudentModifier.chosenTermValue === 'false');
        });
    };

    const validateVehiclesHaveAssignmentsForEveryDriver = (vehicles, drivers, assignments) => {
        let areAssignmentsValid = true;
        vehicles.forEach((vehicle) => {
            // check that each eligible vehicle has an assignment for each rated driver
            drivers.forEach((driver) => {
                const driverFixedId = driver.fixedId;
                const tmpAssignments = assignments.value.filter((a) => a.vehicleID === vehicle.fixedId && a.driverID === driverFixedId);
                if (tmpAssignments.length !== 1) {
                    areAssignmentsValid = false;
                }
            });
        });
        return areAssignmentsValid;
    };

    const validateVehicleAssignmentPercentages = (vehicles, assignments) => {
        let areAssignmentsValid = true;
        vehicles.forEach((vehicle) => {
            const vehicleAssignments = assignments.value.filter((a) => a.vehicleID === vehicle.fixedId);
            const totalPercentage = vehicleAssignments
                .map((val) => val.percentageDriven_Ext)
                .reduce((acc, cur) => parseInt(acc, 10) + (Number.isNaN(parseInt(cur, 10)) ? 0 : parseInt(cur, 10)), 0);
            if (totalPercentage !== 100) {
                areAssignmentsValid = false;
            }
        });
        return areAssignmentsValid;
    };

    const checkDriversForHiLicense = (drivers) => {
        for (const key in drivers) {
            if (drivers[key].licenseState === 'HI' && _.gte(drivers[key].driverAge_Ext, 18 )) {
                return true;
            }
        }
        return false;
    };

    const checkHiDrivers = (driversValue) => {
        return checkDriversForHiLicense(driversValue);
    };

    const checkPendingMvrOrderStatus = (driversValue) => {
        for (const key in driversValue) {
            if (driversValue[key].orderStatus_Ext === 'Ordered') {
                return true;
            }
        }
        return false;
    };

    const hasPALeaseLoanCovButChangedOwnership = (vehicle) => {
        return vehicle.hasPALeaseLoanCov_ML &&
            vehicle.financeCategory_ML !== vehicle.orgFinanceCategory_ML;
    };

    const isFinanceWithoutPALeaseLoanCovButNoLienHolder = (vehicle) => {
        return vehicle.hasPALeaseLoanCov_ML !== true &&
            vehicle.financeCategory_ML === 'financed' &&
            vehicle.additionalInterests.filter((addInt) => addInt.type === 'LIEN').length === 0;
    };

    const isLeaseButNoLessor = (vehicle) => {
        return vehicle.financeCategory_ML === 'leased' &&
            vehicle.additionalInterests.filter((addInt) => addInt.type === 'LEASINGCOMPANY').length === 0;
    };

    const isOwnedButWithLienHolderLessor = (vehicle) => {
        return vehicle.financeCategory_ML === 'owned' &&
            vehicle.additionalInterests.filter((addInt) => {
                return addInt.type === 'LIEN' || addInt.type === 'LEASINGCOMPANY';
            }).length !== 0;
    };

    const getDriverNotListedReasonsForAdding = (driverType, isModernProduct = false, isUMB_NP = false) => {
        switch (driverType) {
            case 'household':
                if (isModernProduct) {
                    return ['unknown', 'deceased', 'never_licensed', 'abroad', 'mission', 'permit', 'not_household'];
                }

                return ['abroad', 'never_licensed', 'own_insurance', 'permit', 'mission'];
            case 'nondriver':
                if(isUMB_NP) {
                    return ['own_insurance', 'abroad','permit', 'mission']
                }
            case 'excluded':
                if (isModernProduct && !isUMB_NP) {
                    return ['own_insurance', 'never_licensed', 'license_revoked', 'unwanted', 'unabletodrive', 'registeredowner'];
                }
                if (isUMB_NP) {
                    return ['license_revoked', 'unwanted', 'unabletodrive', 'registeredowner'];
                }

                return ['license_revoked', 'unwanted'];
            default:
                return [];
        }
    };

    const getUmbrellaDriverNotListedReasonsForAdding = (driverType, isModernProduct = false) => {
        switch (driverType) {
            case 'household':
                if (isModernProduct) {
                    return ['own_insurance', 'abroad', 'mission', 'permit'];
                }

                return ['abroad', 'never_licensed', 'own_insurance', 'permit', 'mission'];
            case 'excluded':
                if (isModernProduct) {
                    return ['license_revoked', 'unwanted', 'unabletodrive', 'registeredowner'];
                }

                return ['license_revoked', 'unwanted'];
            default:
                return [];
        }
    };

    const hasDuplicateSignalPhoneNumbers = (drivers) => {
        clearBlockAlerts('duplicateSignalPhone');
        const seen = new Set();
        let hasDuplicate = false;

        drivers.forEach((driver) => {
            const modifiersList = driver?.driverModifiers_ML?.modifiers;
            if (Array.isArray(modifiersList.value)) {
                modifiersList.value.forEach((modifier) => {
                    if (modifier.codeIdentifier_ML === "PADriverSignalProgramPhoneNumber_Ext"){
                        if(modifier?.chosenTermValue !== null && modifier?.chosenTermValue !== undefined && modifier?.chosenTermValue !== ""){
                            if (seen.has(modifier?.chosenTermValue )) {
                                hasDuplicate = true;
                            } else {
                                seen.add(modifier?.chosenTermValue );
                            }
                        }                        
                    }
                });
            }        });

        return hasDuplicate;
    };

    const isSpouseRemoved = (drivers)=> {
        const driverWithSpouseID = drivers.find((driver) => (
            driver?.spouseID_ML
            && driver?.maritalStatus_ML === 'M'
        ));

        if (!driverWithSpouseID) {
            return true;
        }

        if (drivers.length <=1 && !!driverWithSpouseID){
            return false
        }

        const spouseID = driverWithSpouseID.spouseID_ML;

        return drivers.some((otherDriver) => (
            otherDriver?.person?.publicID === spouseID
            || otherDriver?.person?.tempID === spouseID
        ));
    };

    return {
        hasPALeaseLoanCovButChangedOwnership: hasPALeaseLoanCovButChangedOwnership,
        isFinanceWithoutPALeaseLoanCovButNoLienHolder: isFinanceWithoutPALeaseLoanCovButNoLienHolder,
        isLeaseButNoLessor: isLeaseButNoLessor,
        isOwnedButWithLienHolderLessor: isOwnedButWithLienHolderLessor,
        isTrailer: isTrailer,
        isLowSpeedVehicle: isLowSpeedVehicle,
        isRegisteredGolfCart: isRegisteredGolfCart,
        isPrivatePassenger: isPrivatePassenger,
        isCollectible: isCollectible,
        isVehicleYearPost1980: isVehicleYearPost1980,
        isPartialVinWithoutSymbolsValid: isPartialVinWithoutSymbolsValid,
        isUnlistedModelValid: isUnlistedModelValid,
        isOtherPersonallyRegistered: isOtherPersonallyRegistered,
        isStateAZ: isStateAZ,
        useStateLogicForList: useStateLogicForList,
        isNotLicensed: isNotLicensed,
        isLicensed: isLicensed,
        isDriverRemovalNotAllowed: isDriverRemovalNotAllowed,
        isSamePerson: isSamePerson,
        isSpouse: isSpouse,
        isSpousePresent: isSpousePresent,
        isSelf: isSelf,
        isSelfPresent: isSelfPresent,
        isDriverRemovalExclusion: isDriverRemovalExclusion,
        isDriverNeverLicensed: isDriverNeverLicensed,
        isDriverRemovalAddHouseholdMember: isDriverRemovalAddHouseholdMember,
        isDriverRemovalDuplicate: isDriverRemovalDuplicate,
        isDriverRemovalDeceased: isDriverRemovalDeceased,
        isDriverRemovalUnknown: isDriverRemovalUnknown,
        isDriverRemovalAddRatedDriver: isDriverRemovalAddRatedDriver,
        isDriverRemovalNotInHousehold: isDriverRemovalNotInHousehold,
        isDriverExcluded: isDriverExcluded,
        isDriverHousehold: isDriverHousehold,
        isAccountHolder: isAccountHolder,
        driverNotExcludedOrHousehold: driverNotExcludedOrHousehold,
        getMaleGenderType: getMaleGenderType,
        getOccupationTypeName: getOccupationTypeName,
        getFilteredGender:getFilteredGender,
        getSelfRelationshipToInsured: getSelfRelationshipToInsured,
        getNotInHouseholdDriverStatusType: getNotInHouseholdDriverStatusType,
        getRatedDriverType: getRatedDriverType,
        getExcludedDriverType: getExcludedDriverType,
        getHouseholdDriverType: getHouseholdDriverType,
        getPermittedDriverType: getPermittedDriverType,
        getOutOfHouseholdDriverType: getOutOfHouseholdDriverType,
        getNonDriverType: getNonDriverType,
        getHouseholdNonDriverType: getHouseholdNonDriverType,
        getInsureDriver: getInsureDriver,
        getRatedDrivers: getRatedDrivers,
        getExcludedDrivers: getExcludedDrivers,
        getMaxDateOfBirth: getMaxDateOfBirth,
        getMinDateOfBirth: getMinDateOfBirth,
        getMaxVehicleYears: getMaxVehicleYears,
        getErrorCode: getErrorCode,
        getErrorDescription: getErrorDescription,
        hasErrorCodes: hasErrorCodes,
        mapVinResponseToVehicle: mapVinResponseToVehicle,
        getHighestCompSymbol: getHighestCompSymbol,
        setVehicleInfoWithVinPrefix: setVehicleInfoWithVinPrefix,
        getModelCode: getModelCode,
        isValidYMMRequest: isValidYMMRequest,
        isPropertyDefinedAndNotEmpty: isPropertyDefinedAndNotEmpty,
        readyVehicleForSave: readyVehicleForSave,
        createValidationObj: createValidationObj,
        createVinLookupRequest: createVinLookupRequest,
        createLookupModelsRequest: createLookupModelsRequest,
        createNewPersonVM: createNewPersonVM,
        populateDriverPerson: populateDriverPerson,
        clearVinFields: clearVinFields,
        createOnlyTrailerError: createOnlyTrailerError,
        readyDriverForSave: readyDriverForSave,
        setDriversForPartialCreation: setDriversForPartialCreation,
        validateDriverAddition: validateDriverAddition,
        validateExcludedDriverAddition: validateExcludedDriverAddition,
        validateLastDriverDriverRemoval: validateLastDriverDriverRemoval,
        validateDriverRemoval: validateDriverRemoval,
        getRemoveDriverExcludedOptions: getRemoveDriverExcludedOptions,
        getModernProductRemoveDriverOptions: getModernProductRemoveDriverOptions,
        validateVehicleAddition: validateVehicleAddition,
        validateAgentPrefillNextStep: validateAgentPrefillNextStep,
        setVinIntegrationErrorCode: setVinIntegrationErrorCode,
        checkUniqueSelf: checkUniqueSelf,
        checkUniqueSpouse: checkUniqueSpouse,
        guaranteeUniqueSelf: guaranteeUniqueSelf,
        checkNoSpouse: checkNoSpouse,
        createLookupYMMRequest: createLookupYMMRequest,
        clearPupVinFields: clearPupVinFields,
        validateAntiqueVehicleAge: validateAntiqueVehicleAge,
        validateClassicVehicleAge: validateClassicVehicleAge,
        hasCompCollSymbolsNoYear: hasCompCollSymbolsNoYear,
        validateQuotedCollAndCompCovsRequired: validateQuotedCollAndCompCovsRequired,
        validateVehiclesSerialNumber: validateVehiclesSerialNumber,
        createLookupCompCollRequest: createLookupCompCollRequest,
        isVendorAnnualMileageForPA: isVendorAnnualMileageForPA,
        canDisplayAnnualMileage: canDisplayAnnualMileage,
        pADriverSuspended: pADriverSuspended,
        displayPADriverSuspendedMessage: displayPADriverSuspendedMessage,
        unobtainableDriverLicense: unobtainableDriverLicense,
        displayUnobtainableDriverLicenseMessage: displayUnobtainableDriverLicenseMessage,
        clearUnobtainableDriverLicenseMessage: clearUnobtainableDriverLicenseMessage,
        displayNonAccidentPreventionModifierMessage: displayNonAccidentPreventionModifierMessage,
        displayNonAPModifierLAMessage: displayNonAPModifierLAMessage,
        clearAccidentPreventionMessage: clearAccidentPreventionMessage,
        getFullName: getFullName,
        setDriversForFullAddition,
        setDefaultStatusForRatedDriver,
        setModifierEditMode,
        isAccidentPreventionCourse,
        setSpousesForDriver,
        isVehicleEligibleForAccidentPrevention,
        getRatedDriversNonStudent,
        validateVehiclesHaveAssignmentsForEveryDriver,
        validateVehicleAssignmentPercentages,
        setDefaultSelfRelation: setDefaultSelfRelation,
        checkHiDrivers: checkHiDrivers,
        checkPendingMvrOrderStatus: checkPendingMvrOrderStatus,
        showConnectedCarModifierAlert,
        getDriverNotListedReasonsForAdding,
        getUmbrellaDriverNotListedReasonsForAdding,
        getVehicleDiscountMessage,
        hasDuplicateSignalPhoneNumbers,
        checkDriverRemovalCondition,
        getUmbrellaDriverTypeNewProduct,
        getUmbrellaRemoveDriverOptions,
        checkIfNonDriver,
        qnBDobFieldVisibility,
        getRemoveDriverOptions:getRemoveDriverOptions,
        isSpouseRemoved
    };
}

export default MLDriverVehicleUtil;
